var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-menu-container"},[_c('AppSubmenu',{staticClass:"layout-menu",attrs:{"id":"menu-servidor","items":_vm.model,"root":true},on:{"menuitem-click":_vm.onMenuItemClick,"keydown":_vm.onKeyDown}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }